import { put, take, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { putError, putSuccess } from "../helpers";



function* getPdf(action) {
    try {
        yield put({
            type: actionTypes.POST_POSTER_PDF_COMBINED_REQUEST,
            meta: {},
            payload: action.payload
        })
    
        const pdf = yield take([actionTypes.POST_POSTER_PDF_COMBINED_SUCCESS, actionTypes.POST_POSTER_PDF_COMBINED_ERROR])
        
        if(actionTypes.POST_POSTER_PDF_COMBINED_SUCCESS === pdf.type ) {
            yield putSuccess(actionTypes.PRINT_DATA_PRINT_TYPES_PDF_SUCCESS)
        } else {
            throw new Error('Could not create pdf')
        }
    } catch(e) {
        yield console.log('ERROR', e)
        yield putError(actionTypes.PRINT_DATA_PRINT_TYPES_PDF_ERROR, e.message)
    }
}


function* watchPdfPrintTypesRequest() {
    yield takeLatest(actionTypes.PRINT_DATA_PRINT_TYPES_PDF_REQUEST, getPdf)
}

export default watchPdfPrintTypesRequest